import {
  PermissionExtraParameters,
  PermissionStorage,
} from 'frontcore/domain/authorization/model/PermissionService'

const STORAGE_KEY = 'permission-storage'

export default class PermissionStorageImpl implements PermissionStorage {

  clear (): void {
    localStorage.removeItem(STORAGE_KEY)
  }

  get (): PermissionExtraParameters | undefined {
    const data = localStorage.getItem(STORAGE_KEY)
    if (!data) { return }
    return JSON.parse(data)
  }

  set (data: PermissionExtraParameters): void {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data))
  }

}
